/* eslint-disable no-undef */
/* eslint-disable react/button-has-type */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
import React, {
    useState, useEffect, useContext, useCallback,
} from 'react';
import { motion } from 'framer-motion';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { distributorService } from '../../service/distributor.service';
import IndentListSkeleton from '../MISReports/IndentReport/indentlistSkeleton';
import Pagination from '../../Components/Pagination';
import HeaderContext from '../../Components/Context/HeaderContext';
import EmptyScreen from '../../Components/GlobalEmplyPage';
import BulkOrdersFilterModal from './BulkOrderFilterModal';
import { GenerateDate, GenerateDateandTime, GenerateDateFormat } from '../../redux/helper/DateConverter';
import { PriceHandler } from '../../redux/helper/CamelCase';

function SubscribedBulkOrders() {
    const navigate = useNavigate();
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const { id, disId } = useParams();
    const [BulkOrderList, setBulkOrderList] = useState([]);
    const [bulkorderDetails, setBulkOrderDetails] = useState([]);
    const [sortType, setsortType] = useState('created_at+desc');
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setsearchValue] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [alldata, setalldata] = useState({});
    const [loading, setLoading] = useState(true);
    const [filterModal, setFilterModal] = useState(false);
    const [emptyData, setEmptyData] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [overAllCriteria, setOverAllCriteria] = useState([]);
    const [Filter, setFilter] = useState({
        type: [],
    });
    const [selected, setselected] = useState({
        start_date: '',
        end_date: '',
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');

    const payment_status = {
        0: 'Pending',
        1: 'Partial',
        2: 'Paid',
    };

    const order_status = {
        0: 'Draft',
        1: 'Pending',
        2: 'InProcess',
        3: 'Approved',
        4: 'Out for delivery',
        5: 'Partially Delivered',
        6: 'Deliverd',
        7: 'Completed',
        8: 'Rejected',
        '-1': 'Draft',
    };

    const wf_status = {
        0: 'ASE - Unassigned',
        1: 'ASE -  Assigned',
        3: 'RBM - Approval',
        2: 'RBM - Rejected',
        4: 'Distributor - Accepted',
        9: 'Distributor - Declined',
        5: 'BH - Approved',
        6: 'BH - Rejected',
        7: 'CSD - Approved',
        8: 'CSD - Rejected',
        10: 'ASM - Approved',
        11: 'ASM - Rejected',
        12: 'Costing Approved',
        13: 'Costing Rejected',
        14: 'Accountant Approved',
        15: 'Accountant Rejected',
        16: 'TH - Approved',
        17: 'TH - Rejected',
        18: 'TDC - Approved',
        19: 'TDC - Rejected',
        20: 'Plant Quality Approved',
        21: 'Plant Quality Rejected',
    };

    const handleFetchBulkOrders = useCallback((() => {
        distributorService.BulkOfferSubscriberedOrders(id, currentPage, sortType, searchValue, filterValue).then((response) => {
            if (response.error === false && response.data.success_status === true) {
                if (response.data.data.Items.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setBulkOrderList(response.data.data.Items);
                setalldata(response);
                setCurrentPage(response.data.data.current_page);
                setTotalPage(response.data.data.number_of_pages);
            } else {
                setLoading(false);
                setalldata([]);
            }
        });
    }), [currentPage, searchValue, sortType, filterValue, exportSelected]);

    const handleFetchCriteriaDetails = async () => {
        const response = await distributorService.CartDealList(id, disId);
        if (response.error === false) {
            setOverAllCriteria(response.data.current_critria);
        }
    };

    const handleFetchDetails = async () => {
        const response = await distributorService.BulkOrderDetails(disId, id);
        if (response.error === false && response.data.success_status) {
            setBulkOrderDetails(response.data.data);
        }
    };

    const handleFilter = (filterUrl) => {
        if (filterUrl.length > 0 && filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    const handlePageClick = async (data) => {
        setLoading(false);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleNavigate = () => {
        navigate(-1);
    };

    const handleExport = useCallback((() => {
        distributorService.BulkOfferSubscriberedOrders(id, currentPage, sortType, searchValue, filterValue, exportSelected).then((val) => {
            if (val.data.success_status) {
                // setshowPopup(true);
                SetSuccessMessage('File exported sucessfully!');
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    // settitle('');
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    useEffect(() => {
        handleFetchBulkOrders();
    }, [handleFetchBulkOrders]);

    useEffect(() => {
        handleFetchDetails();
        handleFetchCriteriaDetails();
    }, []);

    return (
        <div className="py-6 main-screen">
            <div className="flex justify-between items-center pb-[18px]">
                <div className="flex items-center">
                    <button onClick={() => handleNavigate()}>
                        <img src="/images/Icon-feather-arrow-left.svg" alt="icon" className="pr-4 cursor-pointer" />
                    </button>
                    <h5 className="text-xs4 font-normal text-[#555259]">{bulkorderDetails?.party_name}</h5>
                </div>
                <div className="flex items-center">
                    <button
                        type="button"
                        className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                        style={{ border: '2px solid #E9EDF4' }}
                        data-bs-toggle="modal"
                        data-bs-target="#filtermodal"
                        onClick={() => setFilterModal(true)}
                    >
                        Filter
                    </button>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input
                            value={searchValue}
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                                setCurrentPage(1);
                            }}
                            autoComplete="off"
                            type="text"
                            name="search"
                            id="search"
                            className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]"
                            placeholder="Search"
                        />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative">
                        <button
                            type="button"
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg"
                            onClick={() => setexportClick(!exportClick)}
                        >
                            Export
                        </button>
                        <ul className={`dropdown-menu sm:min-w-[85px] min-w-[120px] ${exportClick === true ? 'show' : 'hidden'} absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[40] sm:p-3.5 p-1.5`} aria-labelledby="exportDropdown">
                            <li className=" sm:py-1 py-0.5 export border-b border-[#D8D8D8]">
                                <a
                                    className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center"
                                    href="#"
                                    onClick={() => {
                                        setexportSelected('csv');
                                    }}
                                >
                                    CSV

                                </a>
                            </li>
                            <li className=" sm:py-1 py-0.5 border-b border-[#D8D8D8]">
                                <a
                                    className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center"
                                    href="#"
                                    onClick={() => setexportSelected('pdf-converter')}
                                >
                                    PDF

                                </a>
                            </li>
                            <li className=" sm:py-1 py-0.5">
                                <a
                                    className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center"
                                    href="#"
                                    onClick={() => setexportSelected('excel')}
                                >
                                    Excel

                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {(loading && BulkOrderList.length === 0) ? <IndentListSkeleton /> : (
                <div>
                    <div className="flex justify-between">
                        <div className="mt-1.5 ml-[35px] pb-[18px]">
                            <div className="flex items-center">
                                <p className="text-xs2 font-semibold text-[#808285] w-[120px]">
                                    Distributor ID:

                                </p>
                                <p className="text-sm58 font-semibold text-[#090406]">
                                    {' '}
                                    {bulkorderDetails?.distributor_id}
                                </p>
                            </div>
                            <div className="flex items-center">
                                <p className="text-xs2 font-semibold text-[#808285] w-[120px]">
                                    Type:
                                </p>
                                <p className="text-sm58 font-semibold text-[#090406]">{bulkorderDetails?.offer?.industrial_pocket}</p>
                            </div>
                            <div className="flex items-center mt-1">
                                <p className="text-xs2 font-semibold text-[#808285] w-[120px]">
                                    Subscription Id:
                                </p>
                                <p className="text-sm58 font-semibold text-[#090406]">{bulkorderDetails?.subscription_id}</p>
                            </div>
                            <div className="flex items-center mt-1">
                                <p className="text-xs2 font-semibold text-[#808285] w-[120px]">
                                    Bulk Offer Code:
                                </p>
                                <p className="text-sm58 font-semibold text-[#090406]">{bulkorderDetails?.offer_code}</p>
                            </div>
                            <div className="flex items-center mt-1">
                                <p className="text-xs2 font-semibold text-[#808285] w-[120px]">
                                    Subscription Date:
                                </p>
                                <p className="text-sm58 font-semibold text-[#090406]">{GenerateDateandTime(bulkorderDetails?.created_at)}</p>
                            </div>
                        </div>
                        <div className="lg:min-w-[40%] min-w-full h-auto bg-[#E9EDF4] rounded-lg lg:ml-[18px] ml-0 mb-2.5 border-2 border-[#E9EDF4] p-2.5 self-end">
                            <p className="text-[#808285] text-sm font-bold">Progress</p>
                            <div className="h-[80px] overflow-auto dropdown-menu pr-1">
                                {overAllCriteria && Object.entries(overAllCriteria).map(([key, value]) => (
                                    <div className="px-1 mt-4">
                                        <div className="flex justify-between items-center">
                                            <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox4 flex items-center">
                                                <input type="checkbox" id="checkbox-1" checked={value.quantity >= value.MIN_QUANTITY} />
                                                <label htmlFor="checkbox-1" className="text-sm font-bold text-[#555259] pl-2 cursor-pointer">
                                                    Criteria
                                                    {' '}
                                                    {key}
                                                    {' '}
                                                    <span className="text-[#ED1C24]">*</span>
                                                </label>
                                            </div>
                                            <p className="text-xs font-normal text-[#206C00]">{`${value.quantity.toLocaleString('en-IN')}/${value.MIN_QUANTITY.toLocaleString('en-IN')}`}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="flex justify-between border-t border-[#707070] mt-2 pt-2">
                                <p className="font-normal text-sm text-[#000000]">Total Order Qty</p>
                                <p className="text-[#000000] font-semibold sm:text-xs7 text-base">{Object.values(overAllCriteria).reduce((accumulator, currentValue) => accumulator + Number(currentValue.quantity), 0).toLocaleString('en-IN')}</p>
                            </div>
                            <div className="flex justify-between mt-2.5">
                                <p className="font-normal text-sm text-[#000000]">Total Net Amount</p>
                                <p className="text-[#000000] font-semibold sm:text-xs7 text-base">
                                    ₹
                                    {Object.values(overAllCriteria).reduce((accumulator, currentValue) => accumulator + Number(currentValue.total), 0).toLocaleString('en-IN')}
                                </p>
                            </div>
                        </div>
                    </div>
                    {BulkOrderList.length > 0 && (
                        <div className="overflow-auto dropdown-menu pb-7 relative z-[7]" style={{ height: 'calc(100vh - 337px)' }}>
                            <table className="w-full table-auto relative">
                                <thead className="sticky top-0 left-0 z-[2]">
                                    <tr className="bg-[#555259] h-10">
                                        <th className="py-4 px-6 rounded-bl-lg rounded-tl-lg min-w-[160px] text-start bg-[#555259] sticky top-0 left-0" scope="col">
                                            <span className="text-sm29 font-bold text-[#FFFFFF]">
                                                Order No.
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[190px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                Indent Number
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'CREATED_DATE+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'CREATED_DATE+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'CREATED_DATE+asc') {
                                                                setsortType('CREATED_DATE+desc');
                                                            } else if (sortType === 'CREATED_DATE+desc') {
                                                                setsortType('CREATED_DATE+asc');
                                                            } else {
                                                                setsortType('CREATED_DATE+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[200px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                Order Acceptance No.
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[182px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                Order Type
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[182px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                Plant Name
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[170px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                Order Category
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[200px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Order Created Date
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'created_at+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'created_at+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'created_at+asc') {
                                                                setsortType('created_at+desc');
                                                            } else if (sortType === 'created_at+desc') {
                                                                setsortType('created_at+asc');
                                                            } else {
                                                                setsortType('created_at+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[164px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Total Line Items
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[136px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                Order Value
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[140px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                Offer Status
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[192px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                WF Status
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[150px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                Billing Status
                                            </span>
                                        </th>
                                        <th scope="col" className="py-4 px-7 min-w-[140px] text-start rounded-tr-lg rounded-br-lg bg-[#555259] sticky top-0 right-0">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center">
                                                Action
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {BulkOrderList.length > 0 && BulkOrderList.map((order) => (
                                        <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                            <td
                                                className="text-sm font-normal text-[#090406] py-4 px-7 text-start sticky top-0 left-0"
                                                style={{ background: ' rgba(255, 255, 255, 0.45)', backdropFilter: ' blur(5.5px)' }}
                                            >
                                                {order?.order_initial_number}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                                {order?.order_number}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                                {order?.order_acceptance_number}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                                {order?.order_type}
                                            </td>
                                            {(Object.keys(order?.plant_info || {}).length) > 0
                                                ? (
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                        {order?.plant_info.DESCRIPTION}
                                                    </td>
                                                ) : (
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                        -
                                                    </td>
                                                )}
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-center">
                                                {order?.initial_category ? order?.initial_category : '-' }
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-center">
                                                {GenerateDateandTime(order?.created_at)}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-center">
                                                {order?.total_items}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                                {PriceHandler(order?.total_price)}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                                {order_status[order?.status]}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                                {wf_status[order?.work_flow_status]}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7 text-start">
                                                {payment_status[order?.payment_type]}
                                            </td>
                                            <td
                                                className="py-4 px-7 sticky top-0 right-0"
                                                style={{ background: ' rgba(255, 255, 255, 0.45)', backdropFilter: ' blur(5.5px)' }}
                                            >
                                                <Link to={order.status < 3 ? `/manage-pending-approvals/${order.distributor_id}/${order.order_number}/view` : `/manage-orders/${order.distributor_id}/${order.order_number}/view`} className="flex justify-center items-center px-2.5 py-[5px] bg-[#44445E] rounded w-fit text-xs font-normal text-[#fff]">
                                                    View
                                                </Link>
                                            </td>
                                        </tr>

                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
            {!loading && BulkOrderList && BulkOrderList.length > 0 && (
                <Pagination
                    handlePageClick={handlePageClick}
                    totalPage={totalPage}
                    List={alldata}
                    currentPage={currentPage}
                />
            )}
            {filterModal && (
                <BulkOrdersFilterModal
                    filterModal={filterModal}
                    setFilterModal={setFilterModal}
                    setfilterValue={setfilterValue}
                    Filter={Filter}
                    setFilter={setFilter}
                    handleFilter={handleFilter}
                    handleFetchBulkOrders={handleFetchBulkOrders}
                    selected={selected}
                    setselected={setselected}
                    SetSuccessMessage={SetSuccessMessage}
                />
            )}
            {emptyData && (
                <EmptyScreen
                    search="yes"
                    text="no Orders"
                    buttonRequired={false}
                    all={searchValue.length > 0 ? 'under searched term' : 'found'}
                />
            )}
        </div>
    );
}

export default SubscribedBulkOrders;
